import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { TenantStaffAppSidebar } from '@/components/molecules/tenant-staff-app-sidebar';
import { TenantStaffNavHeader } from '@/components/molecules/tenant-staff-nav-header';
import { Loader } from '@/components';
import { routes } from '@/routing';
import { useTenantStaffAuth } from '@/hooks/use-tenant-staff-auth';

export const TenantStaffAuthLayout: React.FC = () => {
  const { isAuthenticated, loading } = useTenantStaffAuth();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.tenantStaffLogin} replace />;
  }

  return (
    <div className="flex w-full h-screen bg-light-gray">
      <SidebarProvider>
        <TenantStaffAppSidebar />
        <SidebarInset>
          <main className="flex flex-col h-full bg-primary-bg-default">
            <TenantStaffNavHeader />
            <div className="pb-6 overflow-auto">
              <Outlet />
            </div>
          </main>
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
};
